'use strict';

angular.module('internal.licenses')
    .controller('InternalLicenses', ['$scope', 'Licenses', function ($scope, Licenses) {
        $scope.loading = true;

        Licenses.get().then(function (licenses) {
            $scope.loading = false;
            $scope.licenses = licenses;
        });
    }])
;